import { SearchTerm } from "./SearchTerm";

const FloorSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "floorName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "building.site.siteName",
        translationKey: "site"
    },
    {
        heading: "Building",
        accessor: "building",
        searchOnName: "building.buildingName",
        translationKey: "building"
    },
    {
        heading: "Level",
        accessor: "level",
        searchOnName: "floorLevel",
        translationKey: "level"
    },
    {
        heading: "I/O Device",
        accessor: "deviceName",
        searchOnName: "deviceName",
        translationKey: "ioDevice",
    },
    {
        heading: "Relay",
        accessor: "actionName",
        searchOnName: "actionName",
        translationKey: "relay"
    }
];

export default FloorSearch;
